import { render, staticRenderFns } from "./RatingDirections.vue?vue&type=template&id=f6226972"
import script from "./RatingDirections.vue?vue&type=script&lang=js"
export * from "./RatingDirections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports